import { createWebElectronApi } from './backend';
export const IS_WEB = typeof window !== 'undefined' && !('electron' in window);
export function isWeb() {
    return IS_WEB;
}
export function installWebPlatform() {
    if (!IS_WEB || window.electron)
        return;
    window.electron = createWebElectronApi();
    localStorage.setItem('useHtmlMenus', 'true');
}
